import { FC } from 'react';
import { TitleStyled } from './style';

const Title: FC<{ children?: any }> = ({ children, ...restProps }) => (
  <TitleStyled {...restProps}>{children}</TitleStyled>
);

export default Title;
